/* tslint:disable */
/* eslint-disable */
export enum StackholderType {
  Contractor = 'Contractor',
  Consultative = 'Consultative',
  Stackholder = 'Stackholder',
  ConstructionAndConsulting = 'ConstructionAndConsulting',
  All = 'All'
}
